// extracted by mini-css-extract-plugin
export default {"modalPages":"iX_iY","modalPages_wide":"iX_iZ","modalPages__nav":"iX_i0","modalPages__content":"iX_i1","modalPages__nav_hidden":"iX_ja"};